export default {
  'multi': 'Multi-Language',
  'af': 'Afrikaans',
  'af-ZA': 'Afrikaans - South Africa',
  'ar': 'Arabic',
  'ar-DZ': 'Arabic - Algeria',
  'ar-TD': 'Arabic - Chad',
  'ar-EG': 'Arabic - Egypt',
  'ar-IR': 'Arabic - Iran',
  'ar-IQ': 'Arabic - Iraq',
  'ar-JO': 'Arabic - Jordan',
  'ar-KW': 'Arabic - Kuwait',
  'ar-LB': 'Arabic - Lebanon',
  'ar-MA': 'Arabic - Morocco',
  'ar-PS': 'Arabic - Palestine',
  'ar-QA': 'Arabic - Qatar',
  'ar-SA': 'Arabic - Saudi Arabia',
  'ar-SD': 'Arabic - Sudan',
  'ar-SY': 'Arabic - Syria',
  'ar-TN': 'Arabic - Tunisia',
  'ar-AE': 'Arabic - UAE',
  'hy': 'Armenian',
  'be': 'Belarusian',
  'bn': 'Bengali',
  'bs': 'Bosnian',
  'bg': 'Bulgarian',
  'ca': 'Catalan',
  'zh-HK': 'Chinese - Cantonese Traditional',
  'zh': 'Chinese - Mandarin Simplified',
  'zh-Hans': 'Chinese - Mandarin Simplified (Hans)',
  'zh-CN': 'Chinese - Mandarin Simplified China',
  'zh-TW': 'Chinese - Mandarin Traditional',
  'zh-Hant': 'Chinese - Mandarin Traditional (Hant)',
  'hr': 'Croatian',
  'cs': 'Czech',
  'da': 'Danish',
  'da-DK': 'Danish - Denmark',
  'nl': 'Dutch',
  'en-AU': 'English - Australia',
  'en': 'English - Global',
  'en-IN': 'English - India',
  'en-NZ': 'English - New Zealand',
  'en-GB': 'English - UK',
  'en-US': 'English - US',
  'et': 'Estonian',
  'fi': 'Finnish',
  'nl-BE': 'Flemish',
  'fr-CA': 'French - Canada',
  'fr': 'French - France',
  'ka': 'Georgian',
  'ka-GE': 'Georgian - Georgia',
  'de': 'German',
  'de-CH': 'German - Switzerland',
  'el': 'Greek',
  'gu': 'Gujarati',
  'gu-IN': 'Gujarati - India',
  'he': 'Hebrew',
  'hi': 'Hindi',
  'hu': 'Hungarian',
  'id': 'Indonesian',
  'it': 'Italian',
  'ja': 'Japanese',
  'kn': 'Kannada',
  'ko': 'Korean',
  'ko-KR': 'Korean - South Korea',
  'lv': 'Latvian',
  'lt': 'Lithuanian',
  'mk': 'Macedonian',
  'ms': 'Malay',
  'mr': 'Marathi',
  'ne': 'Nepali',
  'no': 'Norwegian',
  'fa': 'Persian',
  'pl': 'Polish',
  'pt': 'Portuguese',
  'pt-BR': 'Portuguese - Brazil',
  'pt-PT': 'Portuguese - Portugal',
  'pa': 'Punjabi',
  'pa-IN': 'Punjabi - India',
  'ro': 'Romanian',
  'ru': 'Russian',
  'sr': 'Serbian',
  'sk': 'Slovak',
  'sl': 'Slovenian',
  'es': 'Spanish',
  'es-419': 'Spanish Latin America',
  'sv': 'Swedish',
  'sv-SE': 'Swedish - Sweden',
  'tl': 'Tagalog',
  'ta': 'Tamil',
  'te': 'Telugu',
  'th': 'Thai',
  'th-TH': 'Thai - Thailand',
  'tr': 'Turkish',
  'uk': 'Ukrainian',
  'ur': 'Urdu',
  'vi': 'Vietnamese'
};